// Styles
import Image from 'next/image'
import styles from './styles.module.scss'
import logoBlack from '@/img/logoBlack.png'
import { FormHookProvider, InputPassword } from '@/components/moleculas'
import { useForm } from 'react-hook-form'
import { useContext, useMemo } from 'react'
import Button from '@/components/moleculas/Button/Button'
import { RecoverPasswordContext } from '@/context/guest/Login/RecoverPassword'
import { AuthContext } from '@/context/AuthContext'

export const ChangePassword = () => {
  const { onClick } = useContext(RecoverPasswordContext)
  const { onSubmit } = useContext(AuthContext)
  const methods = useForm()
  const { getValues } = methods

  const inputPassword = useMemo(() => ({
    name: 'password',
    placeholder: 'Ingrese contraseña',
    label: 'Contraseña',
    feedback: false,
    toggleMask: true,
    rules: {
      required: 'La contraseña es requerida.',
      minLength: {
        value: 6,
        message: 'La contraseña debe tener al menos 6 caracteres.'
      }
    },
    className: 'input-bold password-icon'
  }), [])

  const inputPasswordConfirmation = useMemo(() => ({
    name: 'password_confirmation',
    placeholder: 'Ingrese contraseña',
    label: 'Confirmar contraseña',
    feedback: false,
    toggleMask: true,
    className: 'input-bold password-icon',
    rules: {
      required: 'La confirmación de contraseña es requerida.',
      validate: (value) => value === getValues('password') || 'Las contraseñas no coinciden.'
    }
  }), [getValues])

  return (
    <div className={styles.section}>
      <div className={styles.section_container}>
        <div className={styles.section_header}>
          <Image
            width={500}
            height={500}
            alt='general-configuration'
            src={logoBlack}
            className={styles.image}
            loading='lazy'
          />
        </div>
        <FormHookProvider methods={methods} method='POST' onSubmit={onSubmit.handleChangePassword}>
          <h2 className={styles.title}>Actualiza tus accesos</h2>
          <h3 className={styles.text}>Ingresa una nueva contraseña</h3>
          <div className={styles.form}>
            <div className={styles.form_input}>
              <InputPassword {...inputPassword} />
            </div>
            <div className={styles.form_input} style={{ paddingTop: '37px' }}>
              <InputPassword {...inputPasswordConfirmation} />
            </div>
          </div>
          <div className={styles.form_button}>
            <div>
              <Button
                label='Volver'
                type='button'
                rounded
                className='btn-black btn-md'
                onClick={onClick.handleGoBack}
              />
            </div>
            <div>
              <Button
                label='Guardar'
                type='submit'
                rounded
                className='btn-yellow btn-md'
              />
            </div>
          </div>
        </FormHookProvider>
      </div>
    </div>
  )
}
